import { Navigate, useNavigate, useParams } from 'react-router-dom';
import ContentHeader from '../../../../components/Website/ContentHeader';
import './style.scss';
import { Box, Typography } from '@mui/material';
import { WebsiteConstants } from '../../../../data/Constants';
import Parks from '../sections/Parks';
import Hotels from '../sections/Hotels';
import RequestQuote from '../sections/RequestQuote';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import Gallery from '../sections/Gallery';
import { useEffect, useState } from 'react';
import AttractionDialog from '../sections/AttractionDialog';

const Destination = () => {
    const { translate } = useLanguageContext();
    const { key } = useParams();
    const navigate = useNavigate();

    const [selectedAttraction, setSelectedAttraction] = useState<any>(undefined);

    
    useEffect(() => {
        document.getElementById('root')?.scrollTo({ top: 0, behavior: 'smooth' });
    }, [key]);


    const destination = WebsiteConstants.otherDestinations.find(d => d.key === key);

    if (destination === undefined) {
        return <Navigate to="/" replace={true} />;
    }

    return <>
        <ContentHeader title={destination.city} subtitle={destination.state} wallpaper={destination.wallpaper} backTo={() => navigate('/')} />

        <Box className='grid-content-section paddingX-none paddingBottom-none' id='destination'>
            <Box className='grid-content-section paddingY-none display-flex flexdirection-column alignitems-center justifycontent-center gap-28'>
                {
                    translate(destination.description).split('\n').map((d, index) => {
                        return <Typography variant='body1' key={index} className='fontsize-16 lineheight-22 textalign-center' paddingX={2}> {d} </Typography>;
                    })
                }
            </Box>

            <Box paddingY={2} />

            {destination.parks.length > 0 && <Parks items={destination.parks} onClick={item => setSelectedAttraction(item)} />}

            {destination.hotels.length > 0 && <Hotels items={destination.hotels} onClick={item => setSelectedAttraction(item)} />}
            
            {destination.gallery.length > 0 && <Gallery items={destination.gallery} />}

            <RequestQuote variant='default' />
        </Box>

        <AttractionDialog 
            open={selectedAttraction !== undefined}
            handleClose={() => setSelectedAttraction(undefined)}
            attraction={selectedAttraction}
        />
    </>;
}

export default Destination;